import { lazy, Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
// Trigger redeploy
// Layouts
import ListLayout from '@/layouts/ListLayout'
import Festivals from 'views/Festivals'
const DetailLayout = lazy(() => import('@/layouts/DetailLayout'))
// Pages
const Home = lazy(() => import('@/views/Home'))
const List = lazy(() => import('@/views/List'))
const Detail = lazy(() => import('@/views/Detail'))
const AboutUs = lazy(() => import('@/views/AboutUs'))
const Press = lazy(() => import('@/views/PressReleases'))
const PrivacyPolicy = lazy(() => import('@/views/PrivacyPolicy'))

// const SentryTest: React.FC = () => {
//   throw new Error("Sentry test: render-time error");
//   // TypeScript is happy because the function’s return type is JSX.Element
//   // (even though it never reaches a return).
//   // If TS complains, explicitly annotate:
//   // const SentryTest = (): JSX.Element => { throw new Error("...") }
// };

export default function Router() {
  return (
    <Suspense fallback={<></>}>
      <Routes>
        {/*Test Sentry*/}
        {/*<Route path='/sentry' element={<SentryTest />} />*/}
        <Route element={<ListLayout />}>

          {/* Home */}
          <Route
            path='/'
            element={<Home />}
          />
          <Route
            path='/about'
            element={<AboutUs />}
          />
          <Route
            path='/festivals'
            element={<Festivals />}
          />

          <Route
            path='/press'
            element={<Press items={[]} />}
          />

          <Route
            path='/privacy'
            element={<PrivacyPolicy />}
          />

          {/* List Movie */}
          <Route
            path='/:type/:menu'
            element={<List />}
          />
        </Route>


        {/* Detail */}
        <Route element={<DetailLayout />}>
          <Route
            path='/:type/detail/:idOrSlug'
            element={<Detail />}
          />
        </Route>
      </Routes>
    </Suspense>
  )
}
